import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { HttpBaseService } from '@service/http-base.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-warning',
  templateUrl: './custom-warning.component.html',
  styleUrls: ['./custom-warning.component.sass']
})
export class CustomWarningDialogComponent implements OnInit {
  header: string;
  body: string;

  constructor(
    public dialogRef: MatDialogRef<CustomWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private httpService: HttpBaseService,
    private snackBar: MatSnackBar
  ) {
    this.dialogRef.disableClose = true;
    this.header = data.header;
    this.body = data.body;
  }

  ngOnInit() {
   
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
  confirm(): void {
    this.dialogRef.close(true);
  } 
}
